import { useSelector } from 'react-redux';
import { getLocationPayload } from '@/redux/location/selectors';

/**
 * A Next.js-API compatible hook that can be used as a drop-in replacement for
 * any other methods of accessing route params.
 *
 * @example
 * ```tsx
 * // Before
 * const params = useSelector(getLocationPayload);
 * const { payload: params } = pathToAction(<current-route-action>);
 *
 * // After
 * import { useParams } from '@/hooks/location/useParams';
 *
 * const params = useParams();
 */
export function useParams<T extends Record<string, unknown>>(): T {
  return useSelector(getLocationPayload) as T;
}
